import request from '@/utils/request'

//获取运输证列表
export function getTableList(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/list",
        data: data
    })
}

//获取运输证详情
export function detail(data) {
    return request({
        method: 'get',
        url: "/yzdservice/api/enterprise/transport/detail/" + data
    })
}

//删除运输证
export function Delete(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/delete/" + data
    })
}

//获取获取化学品信息
export function getHxpCascader() {
    return request({
        method: 'get',
        url: "/yzdservice/api/enterprise/credentials/common/getHxpCascader"
    })
}

//删除运输证附件
export function deletefile(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/deletefile/" + data
    })
}

//导出
export function excelwriter(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/excelwriter",
        data: data,
        responseType: 'blob',
    })
}

//获取购买证列表
export function purchaseLicenseList(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/purchaseLicenseList",
        data: data
    })
}


//获取调剂证列表
export function purchaseLicenseListByTjz(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/tjzList",
        data: data
    })
}

//获取进口证列表
export function purchaseLicenseListByJkz(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/jkhcList",
        data: data
    })
}

//获取药品证列表
export function purchaseLicenseListByYpz(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/ypzList",
        data: data
    })
}


//获取经办人
export function getjbr() {
    return request({
        method: 'get',
        url: "/yzdservice/api/enterprise/credentials/common/getjbr"
    })
}

//获取往来单位
export function ysdwlist(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/wldw/list",
        data: data
    })
}

//获取行政区划级联树
export function getXzqTree() {
    return request({
        method: 'get',
        url: "/organization/api/xzqh/tree"
    })
}

//获取行政区划级联树
export function getXzqTreeS(id) {
    return request({
        method: 'get',
        url: "/organization/api/xzqh/tree/" + id
    })
}

/**
 *
 zslx
 G", "购买证"
 J", "进口核查证"
 "D", "药品证"
 T", "调剂证"
 */
//根据购买证编号获取已申请数量
export function applicationsNum(type, id) {
    return request({
        method: 'get',
        url: `/yzdservice/api/enterprise/transport/sqsl/${type}/` + encodeURIComponent(encodeURIComponent(id))
    })
}
//核销
export function hexiao(data) {
    return request({
      method: 'put',
      url: "/yzdservice/api/enterprise/transport/WriteOff" ,
      data:data
    })
}
//取消核销
export function qxhx(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/cancelWriteOff",
        data: data
    })
}
//根据购买证编号获取销售单位和购买单位信息
export function xsdwgmdwMessage(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/getEnterpriseInformation",
        data: data
    })
}

//根据调剂证编号获取销售单位和购买单位信息
export function xsdwgmdwMessageByTjz(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/getEnterpriseInformationBytjz",
        data: data
    })
}


//根据进口证编号获取销售单位和购买单位信息
export function xsdwgmdwMessageByJkz(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/getEnterpriseInformationByjkhcz",
        data: data
    })
}


//根据药品证证编号获取销售单位和购买单位信息
export function xsdwgmdwMessageByYpz(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/getEnterpriseInformationByypz",
        data: data
    })
}


//根据化学品编码获取合法使用证明
export function getHfsyzm(data) {
    return request({
        method: 'get',
        url: "/yzdservice/api/enterprise/credentials/common/getHfsyzm?hxpbm=" + data
    })
}

//初始化证件信息
export function getCertificate() {
    return request({
        method: 'get',
        url: "/yzdservice/api/enterprise/credentials/common/getCertificate"
    })
}

//新增/编辑/运输证（暂时保存）
export function addOrEditYSZTemp(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/enterprise/transport/addTemp",
    data: data
  })
}

//新增/编辑/运输证（提交申请）
export function addOrEditYSZ(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/transport/add",
        data: data
    })
}
//根据化学品编码去找单位
export function getdwforhxpBm(data) {
    return request({
        method: 'get',
        url: "/yzdservice/common/hxpDw/" + data
    })
}

//带出购销合同信息
export function getgxhtMes(type, data) {
    return request({
        method: 'get',
        url: `/yzdservice/api/enterprise/credentials/common/getGxhtxx/${type}/` + encodeURIComponent(encodeURIComponent(data))
    })
}
